import { FC } from "react";
import { useBaseGrid } from "../../BaseGrid/Hooks/useBaseGrid";
import BaseGrid from "../../BaseGrid/BaseGrid";
import { OptionsContextActionParameterProperties } from "../../TrueUI/Tables/BaseTable2/TableProperties";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const gridName = "sso_manager";

type SSOManagementProperties = {};

const SSOManagement: FC<SSOManagementProperties> = () => {
  const editIcon = (
    actionOptions: OptionsContextActionParameterProperties<any>
  ) => (
    <IconButton
      aria-label="expand row"
      onClick={() => console.log("next PR", actionOptions)}
    >
      <EditIcon fontSize="small" />
    </IconButton>
  );

  useBaseGrid({
    name: gridName,
    getURL: "api/ssomanager/getmanagergrid",
    columnOptions: [
      {
        fieldName: "CustomerName",
        width: 25,
      },
      {
        fieldName: "HasSSO",
        width: 25,
      },
      {
        fieldName: "AssignedSSO",
        width: 25,
      },
      {
        fieldName: "UnassignedSSO",
        width: 25,
      },
    ],
    advancedOptions: {
      optionsColumnConfiguration: {
        isHidden: false,
        optionType: "component",
      },
      optionsContextActions: {
        contextComponent: editIcon,
      },
    },
  });

  return <BaseGrid name={gridName} />;
};

export default SSOManagement;
